import React, {Component} from 'react'
import ReactDOM, { findDOMNode } from 'react-dom';
import { connect } from 'react-redux'
import { DragSource, DropTarget } from 'react-dnd';
import { addonAddEditInside, addonRemoveInside, addonSortInside } from './../../actions/index.js'
import { ItemTypes } from '../../../../components/Constants';

const builderAddonSource = {
    beginDrag(props){
        return {
            index: props.index
        }
    }
}

const builderAddonTarget = {
    hover(props, monitor, component) {
        const dragIndex = monitor.getItem().index;
        const hoverIndex = props.index;

        if (dragIndex === hoverIndex) {
            return;
        }

        const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();
        const hoverMiddleY = ( hoverBoundingRect.bottom - hoverBoundingRect.top ) / 2;
        const clientOffset = monitor.getClientOffset();
        const hoverClientY = clientOffset.y - hoverBoundingRect.top;

        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
            return;
        }

        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
            return;
        }

        var inputName = props.inputName;
        var riFieldName = inputName.substring( inputName.indexOf('.') + 1 )
        var fieldData = props.state.sppbForm.activeField

        props.addonSortInside( dragIndex, hoverIndex, riFieldName, fieldData )
        monitor.getItem().index = hoverIndex;
    }
}

class BuilderAddonsItem extends Component {


  onClickEditAddon( addonIndex ,addonName, values ) {
      var inputName = this.props.inputName;
      var riFieldName = inputName.substring( inputName.indexOf('.') + 1 );

      this.props.addonAddEditInside( addonName, values, riFieldName, addonIndex )
  }

  onClickRemoveAddon( addonIndex ) {
    var inputName = this.props.inputName;
    var riFieldName = inputName.substring( inputName.indexOf('.') + 1 );
    var fieldData = this.props.state.sppbForm.activeField

    this.props.addonRemoveInside( addonIndex, riFieldName, fieldData )
  }

  render(){
    const { addon, index, connectDragPreview, connectDragSource, connectDropTarget } = this.props;

    return connectDragPreview(connectDragSource(connectDropTarget(
        <div className="sppb-addon-added" key={ addon.id }>
            <div className="info-of-sppb-addon-added">
              <img src={addonsJSON[addon.name].icon} />
              <span>{addonsJSON[addon.name].title}</span>
              <div className="sppb-inside-addon-btns">
                <span
                  onClick = { (e) => {
                    e.preventDefault()
                    this.onClickEditAddon(index, addon.name, addon.settings);
                  }}>
                    <i className="fa fa-pencil-square-o"></i>
                </span>
                <span
                  onClick = { (e) => {
                    e.preventDefault()
                    this.onClickRemoveAddon(index)
                  }}>
                    <i className="fa fa-trash-o"></i>
                </span>
              </div>
            </div>
        </div>

    )))
  }
}

const mapStateToProps = (state) => {
  return {
    state
  }
}

const mapDispatchToProps = ( dispatch ) => {
  return {
    addonAddEditInside: ( addonName, values, riFieldName, addonIndex ) => {
      dispatch( addonAddEditInside( addonName, values, riFieldName, addonIndex ) )
    },
    addonRemoveInside: ( addonIndex, riFieldName, fieldData ) => {
      dispatch( addonRemoveInside( addonIndex, riFieldName, fieldData ) )
    },
    addonSortInside: ( dragIndex, dropIndex, riFieldName, fieldData ) => {
      dispatch( addonSortInside( dragIndex, dropIndex, riFieldName, fieldData ) )
    }
  }
}

var DragSourceDecorator = DragSource( ItemTypes.BUILDERADDON, builderAddonSource,
  function(connect, monitor) {
    return {
      connectDragSource: connect.dragSource(),
      connectDragPreview: connect.dragPreview(),
      isDragging: monitor.isDragging()
    };
  }
);

var DropTargetDecorator = DropTarget(ItemTypes.BUILDERADDON, builderAddonTarget,
  function(connect, monitor) {
    return {
      connectDropTarget: connect.dropTarget(),
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
      isOverCurrent: monitor.isOver({ shallow: true })
    };
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DropTargetDecorator(DragSourceDecorator(BuilderAddonsItem)));



// WEBPACK FOOTER //
// ./src/helpers/form/types/builder-helper/BuilderAddonsItem.js